import { useEffect } from 'react';

export function useBlurOnLoading(isLoading: boolean) {
    useEffect(() => {
        if (isLoading && document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }
    }, [isLoading]);
}
